import showModal from './showModal';
import hideModal from './hideModal';

const ModalUtils = { showModal, hideModal };

export default ModalUtils;
